import { restClient } from '@/Core'

import { toCollection, toStorage } from '../Helpers/diskResponse'

import type { DiskStorage } from '../Contracts/DiskNode'

/** Мої простори з роллю й кореневою папкою: `GET /services/disk/storages`. */
export const LoadDiskStoragesTask = async (): Promise<DiskStorage[]> => {
    const response = (await restClient.get('/services/disk/storages', {}, { forceRefresh: true })) as unknown

    return toCollection(response, toStorage).items
}
